/* import __COLOCATED_TEMPLATE__ from './class-group-jns-alaska-cup-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class VPAPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	@tracked className = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	alaskaPoints = [30,25,20,17,16,15,14,13,12,11,10,9,8,7,6,5,4,3,2,1];
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			let results = (await this.classGroup.get('results')).slice();
			for(const result of results)
			{
				result.calculatedRacePoints = null;
			}
			this.calculateRacePoints();
		}
	}
	
	@action
	async selectClass(event)
	{
		if(event.target.value == '-')
		{
			this.className = null;
		}
		else
		{
			this.className = event.target.value;
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{	
		if(this.classGroup && this.selectedRacePts != null && this.className != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib && result.className == this.className)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null && this.className != null)
		{
			let results = (await this.classGroup.get('results')).slice();
			results = results.filter((result) =>
			{
				return result.className == this.className;
			});
			//sort by region
			results.sort(this.regionSort);
			//collect all the teams
			const regionNames = [];
			for(const result of results)
			{
				if(!regionNames.includes(result.state) && result.state != "Guest")
				{
					regionNames.push(result.state);
				}
			}
			const regions = [];
			for(const region of regionNames)
			{
				regions.push({name:region,count:0});
			}
			//mark results as validforpoints
			for(const result of results)
			{
				result.validForPoints = false;
				for(const region of regions)
				{
					if(region.name == result.state)
					{
						if(region.count < 5 && result.status == "OK")
						{
							result.validForPoints = true;
							region.count++;
						}
					}
				}
			}
			//sort by time
			results.sort(this.placeSort)
			//assign points
			let currentPoints = 0;
			let tiePoints = 0;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					if(result.isTie)
					{
						if(tiePoints < this.alaskaPoints.length)
							result.calculatedRacePoints = this.alaskaPoints[tiePoints];
						currentPoints++;
					}
					else
					{
						if(currentPoints < this.alaskaPoints.length)
							result.calculatedRacePoints = this.alaskaPoints[currentPoints];
						currentPoints++;
						tiePoints = currentPoints;
					}
				}
			}
		}
	}
	
	regionSort(a,b)
	{
		const aClub = a.state || "";
		const bClub = b.state || "";
		return aClub.localeCompare(bClub);
	}
	placeSort(a,b)
	{
		return a.place-b.place;
	}
}